// если импортировать тему как обычно, то линария падает при попытке схавать ее внутри css``. Иначе импортировать не получилось
import {slugify} from '@linaria/utils'
import {type Var} from './cssTheme'

import lightTheme from '../../../../node_modules/@gwc/core/dist/cjs/themes/light'

export const deliveryTheme = {
  ...lightTheme,
  colors: {
    ...lightTheme.colors,
    deliveryGrey: {
      100: '#E6E6E6',
      125: '#DDDCDA',
      150: '#D4D4D0',
      200: '#B3B3B3',
      250: '#999999',
      300: '#808080',
      350: '#666666',
      400: '#4D4D4D',
      450: '#333333',
      500: '#252525',
      550: '#1A1A1A',
    },
    boxBrown: {
      50: '#FBF7F3',
      75: '#F9F1EB',
      100: '#F5EAE1',
      150: '#F0DDCE',
      200: '#F0DCCC',
      250: '#E8CAB2',
      300: '#E5B68F',
      500: '#D29C6F',
    },
    deliveryWidget: {
      green: '#E7F4E0',
      red: '#FFCEBE',
    },
  },
}

const cssVars: Record<string, boolean> = {}

export const createCssVar = (
  keyName: string,
  defaultValue?: string,
): [string, (value: Var | string) => Record<string, Var | string>, string] => {
  const key = `--${keyName}`
  if (key in cssVars) {
    return createCssVar(`${keyName}_${slugify(keyName)}`, defaultValue)
  }
  cssVars[key] = true

  const setVar = (value: Var | string) => ({[key]: value})
  const defaultValueStr = !!defaultValue ? `, ${defaultValue}` : ''

  return [`var(${key}${defaultValueStr})`, setVar, key]
}
